module.exports = __webpack_public_path__ + "img/gabrovo.8769f9df.jpg";